import React, { useState, useEffect } from 'react'
import { useSelector } from 'react-redux'
import { isEmpty } from 'lodash'

import NoData from '@/components/NoData'
import { AdvancedTablePagination } from '@/components/tables/AdvancedTable/AdvancedTablePagination'
import { Card } from '@/components/cards/Card'

import { AgentCallStatusHeader } from './AgentCallStatusHeader'
import { AgentCallStatusEntry } from './AgentCallStatusEntry'

// Lots of duplication for pagination and such - will abstract out if we're using this list view again
export const AgentCallStatusList = () => {
  const [activePage, setActivePage] = useState(1)
  const [rowsPerPage, setRowsPerPage] = useState(10)
  const { loading, agents, listeningToAgent } = useSelector((state) => state.commandCenter)

  const handleUpdateRowsPerPage = (value) => {
    setActivePage(1)
    setRowsPerPage(value)
  }

  useEffect(() => {
    // Reset table if there's a reload
    if (loading.agents) {
      setActivePage(1)
    }
  }, [loading])

  if (isEmpty(agents)) {
    return (
      <Card className="no-padding">
        <div className="empty-table">
          <NoData text="No agents found" />
        </div>
      </Card>
    )
  }

  // Find pagination values
  const count = agents.length
  const calculatedRowsPerPage = rowsPerPage
  const totalPages = Math.ceil(count / calculatedRowsPerPage)

  // Paginate and separate pinned agent
  const pinnedAgent = agents.find((agent) => agent.agent_username === listeningToAgent)
  const filteredRows = agents
    .filter((agent) => agent.agent_username !== listeningToAgent)
    .slice((activePage - 1) * calculatedRowsPerPage, activePage * calculatedRowsPerPage)

  // Render the pinned agent inside the same keyed list as the rest so React
  // preserves the entry's instance when an agent transitions between the
  // pinned slot and the filtered rows. Splitting them across separate JSX
  // expressions resets local state (e.g. the expanded chat panel) every time
  // listeningToAgent changes because React sees the entry as a new mount.
  const orderedAgents = pinnedAgent ? [pinnedAgent, ...filteredRows] : filteredRows

  return (
    <Card title="Monitoring">
      <AgentCallStatusHeader />
      {orderedAgents.map((agent, i) => (
        <AgentCallStatusEntry key={agent.agent_username} agent={agent} index={i} />
      ))}
      <AdvancedTablePagination
        activePage={activePage}
        rowsPerPage={calculatedRowsPerPage}
        handleUpdateRowsPerPage={handleUpdateRowsPerPage}
        count={count}
        totalPages={totalPages}
        setActivePage={setActivePage}
        transparent
        dropdownProps={{ placement: 'bottom-start' }}
        style={{ padding: 0, height: 'auto', marginTop: '1.5rem' }}
      />
    </Card>
  )
}
